"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHCM_ITEM_COLOR = exports.WHCM_DISABLED_ITEM_COLOR = exports.TOP_PLACEMENT_BORDER_RADIUS = exports.OUTLINE_BORDER_WIDTH = exports.LIST_BORDER_RADIUS = exports.INSET_ELEMENT_OUTLINE_OFFSET = exports.INPUT_PADDING_WITH_ICON = exports.INPUT_PADDING_VERTICAL_DEFAULT = exports.INPUT_PADDING_HORIZONTAL_DEFAULT = exports.INPUT_GRID_GAP = exports.INPUT_BORDER_RADIUS = exports.INDETERMINATE_BAR_WIDTH = exports.INDETERMINATE_BAR_HEIGHT = exports.HOVER_INVERTED_COLOR = exports.HOVER_DETAILED_BACKGROUND_COLOR = exports.HOVER_COLOR = exports.HOVER_BACKGROUND_COLOR = exports.HOVERED_RING_SIZE = exports.FOCUS_INVERTED_COLOR = exports.FOCUS_COLOR = exports.ERROR_INVERTED_HOVER_COLOR = exports.ERROR_INVERTED_FOCUS_COLOR = exports.ERROR_INVERTED_DEFAULT_COLOR = exports.ERROR_HOVER_DETAILED_BACKGROUND_COLOR = exports.ERROR_HOVER_COLOR = exports.ERROR_HOVER_BACKGROUND_COLOR = exports.ERROR_FOCUS_COLOR = exports.ERROR_DEFAULT_COLOR = exports.DISABLED_COLOR = exports.DISABLED_BACKGROUND_COLOR = exports.DEFAULT_TEXT_COLOR = exports.DEFAULT_RING_SIZE = exports.DEFAULT_INVERTED_TEXT_COLOR = exports.DEFAULT_INVERTED_COLOR = exports.DEFAULT_COLOR = exports.DEFAULT_BACKGROUND_COLOR = exports.CHECKED_RING_SIZE = exports.CHECKBOX_SELECTED_BORDER_WIDTH = exports.CHECKBOX_BORDER_WIDTH = exports.BOTTOM_PLACEMENT_BORDER_RADIUS = exports.BORDER_INVERTED_COLOR = exports.BORDER_COLOR = void 0;
var CHECKBOX_BORDER_WIDTH = 1;
exports.CHECKBOX_BORDER_WIDTH = CHECKBOX_BORDER_WIDTH;
var CHECKBOX_SELECTED_BORDER_WIDTH = 2;
exports.CHECKBOX_SELECTED_BORDER_WIDTH = CHECKBOX_SELECTED_BORDER_WIDTH;
var OUTLINE_BORDER_WIDTH = 2;
exports.OUTLINE_BORDER_WIDTH = OUTLINE_BORDER_WIDTH;
var INSET_ELEMENT_OUTLINE_OFFSET = -2;
exports.INSET_ELEMENT_OUTLINE_OFFSET = INSET_ELEMENT_OUTLINE_OFFSET;
var INDETERMINATE_BAR_HEIGHT = 2;
exports.INDETERMINATE_BAR_HEIGHT = INDETERMINATE_BAR_HEIGHT;
var INDETERMINATE_BAR_WIDTH = 12;
exports.INDETERMINATE_BAR_WIDTH = INDETERMINATE_BAR_WIDTH;
var DEFAULT_RING_SIZE = 1;
exports.DEFAULT_RING_SIZE = DEFAULT_RING_SIZE;
var HOVERED_RING_SIZE = 4;
exports.HOVERED_RING_SIZE = HOVERED_RING_SIZE;
var CHECKED_RING_SIZE = 8;
exports.CHECKED_RING_SIZE = CHECKED_RING_SIZE;
var INPUT_PADDING_HORIZONTAL_DEFAULT = 16;
exports.INPUT_PADDING_HORIZONTAL_DEFAULT = INPUT_PADDING_HORIZONTAL_DEFAULT;
var INPUT_PADDING_VERTICAL_DEFAULT = 8;
exports.INPUT_PADDING_VERTICAL_DEFAULT = INPUT_PADDING_VERTICAL_DEFAULT;
var INPUT_PADDING_WITH_ICON = 36 + INPUT_PADDING_VERTICAL_DEFAULT;
exports.INPUT_PADDING_WITH_ICON = INPUT_PADDING_WITH_ICON;
var INPUT_BORDER_RADIUS = 'R100';
exports.INPUT_BORDER_RADIUS = INPUT_BORDER_RADIUS;
var BOTTOM_PLACEMENT_BORDER_RADIUS = ['R100', 'R100', 0, 0];
exports.BOTTOM_PLACEMENT_BORDER_RADIUS = BOTTOM_PLACEMENT_BORDER_RADIUS;
var TOP_PLACEMENT_BORDER_RADIUS = [0, 0, 'R100', 'R100'];
exports.TOP_PLACEMENT_BORDER_RADIUS = TOP_PLACEMENT_BORDER_RADIUS;
var LIST_BORDER_RADIUS = 'R100';
exports.LIST_BORDER_RADIUS = LIST_BORDER_RADIUS;
var INPUT_GRID_GAP = 'S200';
exports.INPUT_GRID_GAP = INPUT_GRID_GAP;
var DEFAULT_BACKGROUND_COLOR = 'neutral0';
exports.DEFAULT_BACKGROUND_COLOR = DEFAULT_BACKGROUND_COLOR;
var DEFAULT_COLOR = 'primary70';
exports.DEFAULT_COLOR = DEFAULT_COLOR;
var DEFAULT_INVERTED_COLOR = 'primary40';
exports.DEFAULT_INVERTED_COLOR = DEFAULT_INVERTED_COLOR;
var DEFAULT_TEXT_COLOR = 'neutral90';
exports.DEFAULT_TEXT_COLOR = DEFAULT_TEXT_COLOR;
var DEFAULT_INVERTED_TEXT_COLOR = 'neutral0';
exports.DEFAULT_INVERTED_TEXT_COLOR = DEFAULT_INVERTED_TEXT_COLOR;
var BORDER_COLOR = 'neutral50';
exports.BORDER_COLOR = BORDER_COLOR;
var BORDER_INVERTED_COLOR = 'neutral20';
exports.BORDER_INVERTED_COLOR = BORDER_INVERTED_COLOR;
var HOVER_COLOR = 'primary60';
exports.HOVER_COLOR = HOVER_COLOR;
var HOVER_INVERTED_COLOR = 'primary30';
exports.HOVER_INVERTED_COLOR = HOVER_INVERTED_COLOR;
var HOVER_BACKGROUND_COLOR = 'primary05';
exports.HOVER_BACKGROUND_COLOR = HOVER_BACKGROUND_COLOR;
var HOVER_DETAILED_BACKGROUND_COLOR = 'primary90';
exports.HOVER_DETAILED_BACKGROUND_COLOR = HOVER_DETAILED_BACKGROUND_COLOR;
var FOCUS_COLOR = 'primary70';
exports.FOCUS_COLOR = FOCUS_COLOR;
var FOCUS_INVERTED_COLOR = 'primary50';
exports.FOCUS_INVERTED_COLOR = FOCUS_INVERTED_COLOR;
var ERROR_DEFAULT_COLOR = 'red70';
exports.ERROR_DEFAULT_COLOR = ERROR_DEFAULT_COLOR;
var ERROR_INVERTED_DEFAULT_COLOR = 'red40';
exports.ERROR_INVERTED_DEFAULT_COLOR = ERROR_INVERTED_DEFAULT_COLOR;
var ERROR_HOVER_COLOR = 'red60';
exports.ERROR_HOVER_COLOR = ERROR_HOVER_COLOR;
var ERROR_INVERTED_HOVER_COLOR = 'red30';
exports.ERROR_INVERTED_HOVER_COLOR = ERROR_INVERTED_HOVER_COLOR;
var ERROR_FOCUS_COLOR = 'red70';
exports.ERROR_FOCUS_COLOR = ERROR_FOCUS_COLOR;
var ERROR_INVERTED_FOCUS_COLOR = 'red50';
exports.ERROR_INVERTED_FOCUS_COLOR = ERROR_INVERTED_FOCUS_COLOR;
var ERROR_HOVER_BACKGROUND_COLOR = 'red05';
exports.ERROR_HOVER_BACKGROUND_COLOR = ERROR_HOVER_BACKGROUND_COLOR;
var ERROR_HOVER_DETAILED_BACKGROUND_COLOR = 'red90';
exports.ERROR_HOVER_DETAILED_BACKGROUND_COLOR = ERROR_HOVER_DETAILED_BACKGROUND_COLOR;
var DISABLED_COLOR = 'neutral60';
exports.DISABLED_COLOR = DISABLED_COLOR;
var DISABLED_BACKGROUND_COLOR = 'neutral10'; // Windows system color for disabled items in WHCM

exports.DISABLED_BACKGROUND_COLOR = DISABLED_BACKGROUND_COLOR;
var WHCM_DISABLED_ITEM_COLOR = 'grayText'; // Windows system color for general items in WHCM

exports.WHCM_DISABLED_ITEM_COLOR = WHCM_DISABLED_ITEM_COLOR;
var WHCM_ITEM_COLOR = 'canvasText';
exports.WHCM_ITEM_COLOR = WHCM_ITEM_COLOR;